import { ContentCopy, LockOutlined } from "@mui/icons-material";
import { Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { toast } from "react-toastify";

const copyPassword = async (password) => {
  try {
    await navigator.clipboard.writeText(password);
    toast.success("PDF password copied");
  } catch {
    toast.error("Could not copy to clipboard");
  }
};

/**
 * Tells staff how a downloaded document PDF is locked. Our own encryption shows the password that
 * lifts it; a preserved original says the lock is the issuer's, whose password we never hold.
 */
const PdfProtectionNote = ({ protection = null, password = null }) => {
  if (protection === "ORIGINAL") {
    return (
      <Tooltip title="The issuer's own encryption is kept exactly as downloaded. Its password is not ours.">
        <Chip
          size="small"
          variant="outlined"
          icon={<LockOutlined />}
          label="Original encryption kept"
        />
      </Tooltip>
    );
  }
  if (!password) {
    return null;
  }
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Tooltip title="Enter this in your PDF editor to unlock editing">
        <LockOutlined fontSize="small" color="action" />
      </Tooltip>
      <Typography variant="caption" color="text.secondary">
        PDF password:
      </Typography>
      <Typography variant="caption" sx={{ fontFamily: "monospace", fontWeight: 600 }}>
        {password}
      </Typography>
      <IconButton
        size="small"
        aria-label="Copy PDF password"
        onClick={() => copyPassword(password)}
      >
        <ContentCopy sx={{ fontSize: 14 }} />
      </IconButton>
    </Stack>
  );
};

export default PdfProtectionNote;
